import { render } from "./referralLead.vue?vue&type=template&id=f51828c4&scoped=true&ts=true"
import script from "./referralLead.vue?vue&type=script&lang=ts"
export * from "./referralLead.vue?vue&type=script&lang=ts"

import "./referralLead.vue?vue&type=style&index=0&id=f51828c4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f51828c4"]])

export default __exports__